import API from '../../../services/apiService.js'

var api= new API();


export default {

  // Загрузить данные по бонусам в работе
  async loadBonusInWork ({ commit }) {
    var data=null;
    try{
      data = await api.Get("BonusService/BonusActivation/GetBonusInWork");
      commit('loadBonusInWork', data);
    }catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

// Загрузить выполненные бонусы
  async loadBonusComplited ({ commit }) {
    var data=null;
    try{
      data = await api.Get("BonusService/BonusActivation/GetCompletedBonuses");
      commit('loadBonusComplited', data);
    }catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

  //получить данные клиента по коду
  async getClientByCode({commit}, code) {
    var data=null
    try {
        var getparams = '?BonusCode=' + code;
        data = await api.Get("BonusService/BonusActivation/CheckCode" + getparams)
      return data
    } catch (e) {
      console.log(e);
        throw new Error(e);
    }
  },

  //отправить бонус в работу
  async setBonusInProgress({commit}, id) {
    try {
        var params = '?id=' + id;
        await api.Post("BonusService/BonusActivation/SetBonusInProgress"+ params);
    } catch (e) {
      console.log(e);
        throw new Error(e);
    }
  },

  //завершить бонус
  async setCompleteBonus({commit}, id) {
    try {
      var params = '?id=' + id;
      await api.Post("BonusService/BonusActivation/CompleteBonus"+ params);
    } catch (e) {
      console.log(e);
        throw new Error(e);
    }
  },

  //отменить выполнение бонуса
  async cancelBonus({commit}, id) {
    try {
        var params = '?id=' + id;
        await api.Post("BonusService/BonusActivation/CancelProgressBonus" + params)

    } catch (e) {
      console.log(e);
        throw new Error(e);
    }
  },

}
